import React, { Component } from 'react';
import { Button, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';

import { queryDeleteWorkflowTemplate, queryWorkflowTemplateList } from '@api/workflow';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pagination: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.current = 1;
    this.pageSize = 10;
    this.getWorkflowTemplateListList();
  }

  getWorkflowTemplateListList = () => {
    const params = {};
    params.limit = this.pageSize;
    params.start = this.current;
    queryWorkflowTemplateList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          pagination: {
            total: res.totalSize,
            showSizeChanger: true,
            current: this.current,
            pageSize: this.pageSize,
          },
        });
      }
    });
  };

  deleteWorkflowTemplate = uuid => {
    queryDeleteWorkflowTemplate(uuid).then(res => {
      if (res.statusCode === 200) {
        message.success('删除成功');
        this.getWorkflowTemplateListList();
      } else {
        message.error(res.message);
      }
    });
  };

  // 列表改变
  handleChange = pagination => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getWorkflowTemplateListList();
  };

  columns = () => {
    return [
      {
        title: '模板名字',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <Link to={`/workflow/template/edit/${record.uuid}`}>{record.name}</Link>
        ),
      },
      {
        title: '标签',
        dataIndex: 'sign',
        key: 'sign',
        render: text => <span>{text}</span>,
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => (
          <span>
            <Popconfirm
              onConfirm={() => this.deleteWorkflowTemplate(record.uuid)}
              title="确定删除当前组织吗？"
              placement="topRight"
              overlayStyle={{ width: 200 }}
            >
              <a className="ant-dropdown-link">删除</a>
            </Popconfirm>
          </span>
        ),
      },
    ];
  };

  render() {
    const { data, pagination } = this.state;
    return (
      <div>
        <Link to="/workflow/template/add">
          <Button type="primary" icon="plus" style={{ marginBottom: 15 }}>
            添加
          </Button>
        </Link>
        <Table
          rowKey="uuid"
          dataSource={data}
          rowSelection={{}}
          pagination={pagination}
          columns={this.columns()}
          style={{ background: '#fff' }}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/Index.js